
import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { filter } from 'rxjs';
import { PowerbiService } from 'src/core/services/powerbi.service';
import { SelectedsystemService } from 'src/core/services/selectedsystem.service';
import { environment } from 'src/environments/environment';
import { PowerbiPageComponent } from "../../powerbi-page/powerbi-page.component";
import { ModalService } from 'src/core/services/modal.service';
import { models } from 'powerbi-client';
import { DaterangeService } from 'src/core/services/daterange.service';
import { SelectedContentService } from 'src/core/services/selectedcontent.service';

@Component({
  selector: 'app-autocheck',
  imports: [PowerbiPageComponent],
  templateUrl: './autocheck.component.html',
  styleUrl: './autocheck.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AutocheckComponent {

  constructor(
    private powerbiService: PowerbiService,
    private selectedSystemService: SelectedsystemService,
    private modalService: ModalService,
    private daterangeService: DaterangeService,
    private selectedContentService: SelectedContentService
  ) { }

  embedToken: string;
  filter: { value: string; type: string }[];
  powerbifilters;

  ngOnInit(): void {

    this.modalService.$modalChanged.subscribe((modal) => {

      this.filter = modal.filter || [];

      this.filter = this.filter[0]?.value ? this.filter : this.powerbiService.getAutocheckData()?.map(data => data.name);

      if (modal && modal.modal === 'autocheck' && modal.open === true) {

        let reportId = environment.modals.fleet.reportId;
        let groupId = environment.modals.fleet.groupId;

        this.powerbiService.getEmbedToken({ reportId, groupId })

          .subscribe({
            next: (token) => {

              //const module = this.selectedSystemService.$systemhealth.value?.module_type;
              let moduleType = this.selectedSystemService.$ibaseinformation.value.module_type;
              if(moduleType === 'SH Prime') {
                moduleType = this.filter[0].value === 'Magline' ? 'VMM' : 'SH'
              } 
              const module = this.validateModuleType(moduleType);

              const datefilter: models.IRelativeDateFilter = {
                $schema: "https://powerbi.com/product/schema#relativeDate",
                target: { table: "Dates", column: "Date" },
                operator: models.RelativeDateOperators.InLast,
                timeUnitsCount: this.daterangeService.$selectedRangeSystemHealth.value,
                timeUnitType: models.RelativeDateFilterTimeUnit.Days,
                includeToday: true,
                filterType: models.FilterType.RelativeDate
              }

              if (module === "VMM") {
              
                this.powerbifilters = [
                  {
                    $schema: "https://powerbi.com/product/schema#basic",
                    target: {
                      table: "Nodes",
                      column: "Serial Number",
                    },
                    operator: "In",
                    values: [this.selectedContentService.currentSystem.SerialNumber],
                  },
                  datefilter
                ];

              } else {
                this.powerbifilters = [
                  {
                    $schema: "https://powerbi.com/product/schema#basic",
                    target: {
                      table: "Nodes",
                      column: "Serial Number",
                    },
                    operator: "In",
                    values: [this.selectedContentService.currentSystem.SerialNumber],
                  },
                  {
                    $schema: "https://powerbi.com/product/schema#basic",
                    target: {
                      table: this.getTestGroupByType(module)[0],
                      column: this.getTestGroupByType(module)[1],
                    },
                    operator: "In",
                    values: this.filter[0].value ? [this.filter[0].value] : this.filter,
                  },
                  datefilter
                ];

              }


              this.embedToken = token[0]["accessToken"];
            }
          });
      }
    });
  }
  validateModuleType(moduleType: string) {
    switch (moduleType) {
      case "CC":
        return "CC"
      case "IA":
        return "IA"
      case "SH Additional":
      case "SH":
        return "SH"
      case "CI":
      case "CI 1900 Analyzer":
        return "CI"
      case "SHC":
      case "SH Connect":
        return "SHC"
      case "VMM":
        return "VMM"
      case "DL":
        return "DL"
      default:
        return null
    }
  }

  getReportModal() {

    //const module = this.selectedSystemService.$systemhealth.value?.module_type === 'SH Connect' ? 'SHC' : this.selectedSystemService.$systemhealth.value?.module_type;
    let moduleType = this.selectedSystemService.$ibaseinformation.value.module_type;
    if(moduleType === 'SH Prime') {
      moduleType = this.filter[0].value === 'Magline' ? 'VMM' : 'SH'
    } 
    const module = this.validateModuleType(moduleType);


    return {
      reportId: environment.modals.fleet.reportId,
      groupId: environment.modals.fleet.groupId,
      pageId: environment.modals.fleet.autocheck?.[module].pageid
    }

  }

  getTestGroupByType(module: string) {
    switch (module) {
      case "CC":
        return ["Autocheck Groups CC", "Test Group CC"]
      case "IA":
        return ["Autocheck Groups IA", "Test Group IA"]
      case "SH":
        return ["Autocheck Groups SH", "Test Group SH"]
      case "CI":
        return ["Autocheck Tests CI","Test Engine"]
      case "SHC":
      case "SH Connect":
        return ["Autocheck Tests SHC","Device SHC"]
      case "VMM":
        return ["Autocheck Tests VMM","Test Device"]
      case "DL":
        return ["Autocheck Tests (DL)","Tests DL"]
      default:
        return null
    }
  }

}
